import {
  FilterArea,
  useFilterAreaContentContext,
} from "#src/components/FilterArea";
import useLocalization from "#src/hooks/useLocalization";
import {
  DropdownInput,
  type StorageKeys,
} from "@validereinc/common-components";
import { Activities } from "@validereinc/domain-controllers";
import React from "react";
import { z } from "zod";

const { ActivityActionOptions, ActivityResourceTypeOptions } = Activities.view;

export const ActivityLogFilterSchema = z
  .object({
    action: z.string(),
    resource_type: z.string(),
  })
  .partial();
export const ActivityLogFilterSchemaKeys = ActivityLogFilterSchema.keyof().Enum;
export type ActivityLogFiltersType = z.infer<typeof ActivityLogFilterSchema>;

export const ActivityLogFilterAreaContent = () => {
  const { localize } = useLocalization();
  const { handleOnChange } = useFilterAreaContentContext();

  const LocalizedActivityResourceTypeOptions = Object.entries(
    ActivityResourceTypeOptions
  ).map(([_key, value]) => ({
    label: localize(value.label),
    id: value.value,
  }));

  return (
    <>
      <DropdownInput
        name={ActivityLogFilterSchemaKeys.action}
        label="Type"
        valueKey="value"
        labelKey="label"
        options={ActivityActionOptions}
        placeholder="Select Change Type"
        description="Filter by Change Type"
        isInline
        isOptionalTextShown={false}
        isLabelShown={false}
        onChange={(val: string) =>
          handleOnChange(val, ActivityLogFilterSchemaKeys.action)
        }
      />
      <DropdownInput
        name={ActivityLogFilterSchemaKeys.resource_type}
        label="Resource Type"
        valueKey="id"
        labelKey="label"
        options={LocalizedActivityResourceTypeOptions}
        placeholder="Select Resource Type"
        description="Filter by Resource Type"
        isInline
        isOptionalTextShown={false}
        isLabelShown={false}
        onChange={(val: string) =>
          handleOnChange(val, ActivityLogFilterSchemaKeys.resource_type)
        }
      />
    </>
  );
};

export const ActivityLogFilterArea = ({
  viewConfigStorageKey,
}: Pick<StorageKeys, "viewConfigStorageKey">) => {
  return (
    <FilterArea.Root
      storageKey={viewConfigStorageKey}
      applyDefaultValues
      shouldPrioritizeStoredFiltersWhenApplyingDefaultValues
    >
      <FilterArea.Container style={{ marginBottom: 16 }}>
        <FilterArea.Content>
          {() => (
            <div
              style={{
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              <ActivityLogFilterAreaContent />
            </div>
          )}
        </FilterArea.Content>
      </FilterArea.Container>
    </FilterArea.Root>
  );
};
